export default __webpack_public_path__ + "static/media/landing-gif.d63221e4.gif";